import styled from 'styled-components';

export const ContactContainer = styled.div`
    display: flex;
    align-items: center;
    margin: 0.75rem 0;
`;
